import { Link } from "react-router-dom";
import type { ArticleItem } from "@/mocks/articles";
import { formatDate } from "@/lib/content";

interface ArticleListItemProps {
  item: ArticleItem;
  compact?: boolean;
}

export default function ArticleListItem({ item, compact = false }: ArticleListItemProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-200 hover:border-primary-300 md:gap-4 md:p-4"
    >
      <div
        className={`relative shrink-0 overflow-hidden rounded-md bg-background-100 ${
          compact ? "w-24 sm:w-28" : "w-28 sm:w-36"
        }`}
        style={{ aspectRatio: compact ? "4 / 3" : "3 / 2" }}
      >
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} 资讯配图`}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
          {item.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {item.summary}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-x-3 gap-y-1 pt-2 text-[11px] text-foreground-500 md:text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {formatDate(item.date)}
          </span>
          {item.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-accent-100 px-2 py-0.5 font-medium text-accent-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}